import {LegacyRef, SyntheticEvent} from 'react';
import {styled} from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

type Props = {
  handleUpload: (event: SyntheticEvent) => void;
  ref: LegacyRef<HTMLInputElement>;
  accept: string;
};
const UploadInput = (props: Props) => {
  return (
    <VisuallyHiddenInput
      type="file"
      ref={props.ref}
      accept={props.accept}
      onChange={props.handleUpload}
    />
  );
};

export default UploadInput;
